export const category_status = [{
        id: 1,
        name: "Activa"
    },
    {
        id: 2,
        name: "Inactiva"
    }
];


// WEBPACK FOOTER //
// ./src/components/product_categories/mocks.js